import { Component, HostBinding } from '@angular/core';
import { AuthService } from '@core/services/auth.service';
import { DashboardService } from './dashboard.service';

@Component({
    selector: 'ms-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent {
  @HostBinding('class.yellow')
    isStudent: boolean = false;

  @HostBinding('class.purple')
    isTeacher: boolean = false;

  isAdmin: boolean;

  isModerator: boolean;

  isManager: boolean;

  isStaff: boolean;

  get isShrinkFixed() {
    return this._dashboardService.isShrinkFixed;
  }

  constructor(private readonly _authService: AuthService, private readonly _dashboardService: DashboardService) {}

  ngOnInit() {
    this.updateUser();
    this._authService.onLogin.subscribe(() => this.updateUser());
    this._authService.onLogout.subscribe(() => this.updateUser());
  }

  updateUser() {
    if (this._authService.isLogged) {
      const accountType = this._authService.accountType;
      if (accountType === 'student') {
        this.isStudent = true;
      } else if (accountType === 'teacher' || accountType === 'coach') {
        this.isTeacher = true;
      } else if (accountType === 'moderator' || accountType === 'superuser') {
        this.isModerator = true;
      } else if (accountType === 'admin') {
        this.isAdmin = true;
      } else if (accountType === 'manager') {
        this.isManager = true;
      } else if (accountType === 'anonymous' || this._authService.parsedToken?.username === 'staff') {
        this.isStaff = true;
        this.isTeacher = true; // Для staff аккаунта показываем боковое меню учителя
      }
    } else {
      this.isStudent = false;
      this.isTeacher = false;
      this.isModerator = false;
      this.isAdmin = false;
    }

    // TODO: Временно менеджера и админа сделали "учителя", чтобы показывать боковое меню учителя для них.
    this.isTeacher = this.isTeacher || this.isModerator || this.isAdmin || this.isManager;
  }

  onScroll(event: Event) {
    this._dashboardService.scrollEvents.next(event);
  }
}
